import { createSpacingMediaQuery, mediaQueriesArray, validateSpacingUnits } from './createMediaQuery';
import type { ResponsiveSpacing } from './types';

const pxToRem = (pxValue: number | string) => {
  if (typeof pxValue === 'string' && /^-?\d*px$/.test(pxValue)) {
    pxValue.replace('px', '');
  }
  return Number(pxValue) ? `${Math.round((Number(pxValue) / 16) * 100_000) / 100_000}rem` : 0;
};

export const createResponsiveSpacingStyle = (cssProp: string, value: ResponsiveSpacing) => {
  if (typeof value === 'number') {
    return `${cssProp}: ${pxToRem(value)}`;
  } else if (typeof value === 'string') {
    return `${cssProp}: ${validateSpacingUnits(value)}`;
  } else if (Array.isArray(value)) {
    return mediaQueriesArray(cssProp, value, createSpacingMediaQuery);
  }
  return null;
};
